import { render, staticRenderFns } from "./singleFileUpload.vue?vue&type=template&id=d54bba38"
import script from "./singleFileUpload.vue?vue&type=script&lang=js"
export * from "./singleFileUpload.vue?vue&type=script&lang=js"
import style0 from "./singleFileUpload.vue?vue&type=style&index=0&id=d54bba38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports